var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-slider-arrow',
                        view: publicPath + 'sprite.svg#view-icon-slider-arrow',
                        viewBox: '0 0 50 99',
                        title: 'icons/fonctions/slider-arrow',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };